import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HiCheckCircle, HiExclamationTriangle, HiInformationCircle } from 'react-icons/hi2';
import { HiX } from 'react-icons/hi';
import { toast as toastBus } from '../../utils/toast';

const typeStyles = {
  success: { bg: 'bg-green-600', icon: <HiCheckCircle className="h-5 w-5" /> },
  error: { bg: 'bg-red-600', icon: <HiExclamationTriangle className="h-5 w-5" /> },
  info: { bg: 'bg-gray-900', icon: <HiInformationCircle className="h-5 w-5" /> },
};

export default function Toaster() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const unsub = toastBus.subscribe(evt => {
      setItems(prev => [...prev, evt]);
      if (evt.duration !== Infinity) {
        setTimeout(() => {
          setItems(prev => prev.filter(t => t.id !== evt.id));
        }, evt.duration || 3500);
      }
    });
    return unsub;
  }, []);

  const dismiss = id => setItems(prev => prev.filter(t => t.id !== id));

  return (
    <div className="pointer-events-none fixed inset-0 z-[100] flex flex-col items-end gap-2 p-4">
      <AnimatePresence>
        {items.map(item => {
          const sty = typeStyles[item.type] || typeStyles.info;
          return (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 20, scale: 0.98 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 10, scale: 0.98 }}
              transition={{ duration: 0.18 }}
              className={`pointer-events-auto flex max-w-sm items-start gap-3 rounded-lg ${sty.bg} p-3 text-white shadow-lg`}
            >
              <div className="mt-0.5 shrink-0">{sty.icon}</div>
              <div className="min-w-0 flex-1 text-sm font-medium">{item.message}</div>
              <button
                onClick={() => dismiss(item.id)}
                className="rounded-md p-1 text-white/80 transition-colors hover:bg-white/10 hover:text-white"
              >
                <HiX className="h-4 w-4" />
              </button>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
